import defaultItems from '../../../../../common/defaultItems';

const formatDate = (date) => {
    const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    const dayAffixes = {
        1: 'st',
        2: 'nd',
        3: 'rd',
        4: 'th',
        5: 'th',
        6: 'th',
        7: 'th',
        8: 'th',
        9: 'th',
        0: 'th',
    };
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    const lastDigit = day.toString().split('').pop();
    return `${monthNames[monthIndex]} ${day}${dayAffixes[lastDigit]}, ${year}`;
};

export default function () {
    return {
        index: '',
        type: 'STATIC_BLOCK',
        title: 'Headline text',
        thumbnailUrl: null,
        content: {
            columnNum: 1,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#ffffff',
            paddingTop: 20,
            paddingBottom: 20,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '',
                    size: 1,
                    columnItems: [
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                align: 'center',
                                fontSize: '22px',
                                lineHeight: '26.4px',
                                textMarkupValue: `<p>${formatDate(new Date())}</p>\n`,
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                align: 'center',
                                fontSize: '36px',
                                lineHeight: '54px',
                                textMarkupValue: '<h2>Newsletter Title</h2>\n',
                                paddingTop: 0,
                                paddingBottom: 0,
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                align: 'center',
                                paddingTop: 5,
                                textMarkupValue: '<p>Subtitle or description of content</p>\n',
                            },
                        },
                    ],
                },
            ],
        },
    };
}
